@if (!errorMessage) {
  <div class="min-h-screen px-5 pb-64 pt-6">
    @if (checkId$ | async) {
      @if (forceType(outstandingAmount) <= 0) {
        <div class="flex items-center justify-center pb-3 md:w-8/12">
          <span><i class="icon icon-n-check text-3xl text-success-600 md:text-4xl"></i></span>
          <p
            class="text-accent ml-3 text-2xl font-bold leading-8 text-neutral-800 md:ml-4 md:text-5xl"
          >
            {{ 'pay-at-table.overview.bill-payed' | translate }}
          </p>
        </div>
        <div class="pb-3 md:w-8/12">
          <div class="mb-3 flex flex-col rounded-m bg-neutral-100 p-5 text-center md:mb-8 md:p-6">
            <p class="font-accent text-md font-bold text-neutral-800 md:text-29px">
              {{ 'pay-at-table.overview.thanks-for-visit' | translate }}
            </p>
          </div>
        </div>
      }
    }
    @if (forceType(outstandingAmount) > 0) {
      <div class="mb-1 flex items-center justify-between">
        <h1 class="m-0 font-accent text-2xl font-bold text-neutral-800">
          {{ 'pay-at-table.overview.title' | translate }}
        </h1>
        <app-button-atom
          [type]="'light'"
          [aspectSquare]="true"
          [size]="'S'"
          [color]="'primary'"
          [disabled]="reloadState === 'loading'"
          [icon]="
            reloadState === 'idle'
              ? 'icon-redo-arrow'
              : reloadState === 'success'
                ? 'icon-check-plain'
                : ''
          "
          [iconUrl]="reloadState === 'loading' ? 'assets/images/spinner.svg' : ''"
          (clickEventEmitter)="onReloadClick()"
          class="ml-2"
        >
        </app-button-atom>
      </div>
    }
    @if (shop$ | async; as shop) {
      @if (shop?.name) {
        <p class="mb-6 font-base text-sm text-neutral-600">
          <span> {{ shop.name }}</span>
          @if (onsiteLocation$ | async; as onsite) {
            <span> — {{ onsite.name }}</span>
          }
        </p>
      } @else {
        <p class="mb-3 h-6 w-9/12 animate-pulse rounded bg-neutral-200"></p>
      }
    }
    @if (items$ | async; as items) {
      @if (items?.length) {
        @for (item of items; track item.id) {
          <div
            class="flex items-start border-b border-neutral-300 py-3"
            [class.cursor-pointer]="shouldShowCheckItemDescription(item)"
            (click)="onCheckItemRowClick(item)"
          >
            <div class="mr-2 shrink-0">
              <app-quantity-atom [quantity]="1"></app-quantity-atom>
            </div>
            <div class="flex min-w-0 flex-1 items-start justify-between gap-2">
              <div class="min-w-0">
                <p class="m-0">
                  <span class="inline-block font-base text-base font-bold leading-6 lg:text-md">{{
                    item.name
                  }}</span>
                </p>
                @if (shouldShowCheckItemDescription(item)) {
                  <p
                    class="mt-0.5 font-base text-sm text-neutral-600"
                    [class.truncate]="!isCheckItemDescriptionExpanded(item.id)"
                    [class.leading-5]="!isCheckItemDescriptionExpanded(item.id)"
                    [class.whitespace-normal]="isCheckItemDescriptionExpanded(item.id)"
                    [class.break-words]="isCheckItemDescriptionExpanded(item.id)"
                  >
                    {{ item.description }}
                  </p>
                }
              </div>
              <span class="shrink-0">
                <app-price-atom
                  [amount]="item.price"
                  [format]="true"
                  [bold]="false"
                ></app-price-atom>
              </span>
            </div>
          </div>
        }
      } @else {
        @for (i of [].constructor(5); track $index) {
          <div class="flex w-full items-center justify-between border-b border-neutral-300 py-3">
            <div class="flex w-9/12">
              <p class="h-6 w-6 animate-pulse rounded-2xl bg-neutral-400"></p>
              <p class="ml-2 h-6 w-7/12 animate-pulse bg-neutral-200"></p>
            </div>
            <div class="h-6 w-10 animate-pulse bg-neutral-200"></div>
          </div>
        }
      }
    }
    <ng-container>
      @if (checkId$ | async) {
        <div class="flex justify-between pb-5 pt-3">
          <span class="font-base text-base font-bold leading-6">{{
            'pay-at-table.overview.total' | translate
          }}</span>
          <span class="font-base text-base font-bold leading-6"
            ><app-price-atom [amount]="forceType(finalPrice$ | async)"></app-price-atom
          ></span>
        </div>
      } @else {
        <div class="mt-3 flex justify-between">
          <p class="mb-3 h-5 w-6/12 animate-pulse rounded bg-neutral-400"></p>
          <p class="mb-3 h-5 w-2/12 animate-pulse rounded bg-neutral-400"></p>
        </div>
      }
    </ng-container>
    @if (transactions$ | async; as transactions) {
      @for (transaction of transactions; track transaction) {
        <div class="border-b border-neutral-300 py-4 font-accent leading-6">
          <div class="flex justify-between">
            <p class="font-bold">
              @switch (transaction.source) {
                @case (checkTransactionSources.DOOD) {
                  <span>
                    {{ 'pay-at-table.overview.payment-online-label' | translate }}
                  </span>
                }
                @case (checkTransactionSources.CashRegister) {
                  <span>
                    {{ 'pay-at-table.overview.payment-cash-register-label' | translate }}
                  </span>
                }
                @default {
                  <span>
                    {{ 'pay-at-table.overview.payment-label' | translate }}
                  </span>
                }
              }
            </p>
            <p
              class="pl-2 font-base"
              [ngClass]="{
                'opacity-50': transaction.status !== checkTransactionStatuses.Captured,
                'line-through': transaction.status === checkTransactionStatuses.Cancelled,
              }"
            >
              <app-price-atom
                [format]="true"
                [amount]="transaction.amount * -1"
                [bold]="false"
                [withParenthesis]="transaction.status !== checkTransactionStatuses.Captured"
              ></app-price-atom>
            </p>
          </div>
          <!-- Transaction timestamp info -->
          <p class="mt-1 flex items-center font-base text-xs text-neutral-500">
            <span>{{ formatDateTime(transaction.created_at) }}</span>
            <span class="mx-1.5">•</span>
            @switch (transaction.status) {
              @case (checkTransactionStatuses.Captured) {
                <i class="icon icon-n-check text-xs text-success-600"></i>
                @if (transaction.confirmed_at) {
                  <span class="ml-1">{{ formatTime(transaction.confirmed_at) }}</span>
                }
              }
              @case (checkTransactionStatuses.Cancelled) {
                <i class="icon icon-n-cross text-xs text-error-600"></i>
              }
              @default {
                <i class="icon icon-clock text-xs text-yellow-600"></i>
              }
            }
            <span class="mx-1.5">•</span>
            <span class="uppercase">#{{ transaction.id | slice: -6 }}</span>
          </p>
          @if (transaction?.tip) {
            <div class="flex justify-between text-neutral-600">
              <p class="flex items-center font-base text-sm">
                <i class="icon icon-satisfied mr-1"></i
                >{{ 'pay-at-table.overview.tip' | translate }}
              </p>
              <p class="pl-2 font-base text-base leading-6">
                <app-price-atom
                  [format]="true"
                  [amount]="transaction?.tip?.amount"
                  [bold]="false"
                ></app-price-atom>
              </p>
            </div>
          }
          @switch (transaction.status) {
            @case (checkTransactionStatuses.Authorized) {
              <p
                class="mt-2 inline-block rounded bg-yellow-100 px-2 py-1 font-base text-sm text-yellow-800"
              >
                {{ 'pay-at-table.overview.payment-status-authorized-label' | translate }}
              </p>
            }
            @case (checkTransactionStatuses.Payment) {
              <p
                class="mt-2 inline-block rounded bg-yellow-100 px-2 py-1 font-base text-sm text-yellow-800"
              >
                {{ 'pay-at-table.overview.payment-status-authorized-label' | translate }}
              </p>
            }
            @case (checkTransactionStatuses.Cancelled) {
              <p
                class="mt-2 inline-block rounded bg-error-100 px-2 py-1 font-base text-sm text-error-800"
              >
                {{ 'pay-at-table.overview.payment-status-cancelled-label' | translate }}
              </p>
            }
            @case (checkTransactionStatuses.CapturedButInconsistentWithRemote) {
              <p class="font-base text-sm text-error-800">
                {{ 'pay-at-table.overview.payment-status-inconsistent-label' | translate }}
              </p>
            }
          }
          @if (getTransactionItems(transaction.items); as transactionItems) {
            @if (transactionItems.length) {
              <div class="mt-2 space-y-1">
                @for (item of transactionItems; track item.name + $index) {
                  <div class="flex items-center justify-between font-base text-sm text-neutral-600">
                    <span class="text-neutral-800">{{ item.name }}</span>
                    <span class="ml-2 text-neutral-600">
                      <app-price-atom
                        [amount]="item.price"
                        [format]="true"
                        [bold]="false"
                      ></app-price-atom>
                    </span>
                  </div>
                }
              </div>
            }
          }
        </div>
      }
    }
    <ng-container>
      @if (checkId$ | async) {
        <div class="flex justify-between py-3">
          <span class="font-accent text-md font-bold leading-6">{{
            'pay-at-table.overview.left-to-pay' | translate
          }}</span>
          <span class="font-accent text-base font-bold leading-6"
            ><app-price-atom [amount]="forceType(outstandingAmount)"></app-price-atom
          ></span>
        </div>
      } @else {
        <div class="flex justify-between">
          <p class="mb-3 h-5 w-6/12 animate-pulse rounded bg-neutral-400"></p>
          <p class="mb-3 h-5 w-2/12 animate-pulse rounded bg-neutral-400"></p>
        </div>
      }
    </ng-container>
    @if (forceType(outstandingAmount) > 0) {
      <app-pat-base-modal>
        @if (!error) {
          <p class="mb-3 text-center font-base text-neutral-800">
            {{ 'pay-at-table.overview.left-to-pay' | translate }} :
            <app-price-atom
              [amount]="forceType(outstandingAmount)"
              [bold]="false"
            ></app-price-atom>
          </p>
          <app-button-atom
            class="mx-auto"
            [disabled]="!outstandingAmount || !!!(checkId$ | async) || isLoading"
            [iconUrl]="isLoading ? 'assets/images/spinner.svg' : ''"
            [label]="'pay-at-table.choose-payment-button' | translate"
            [full]="true"
            (click)="goToChooseAmount()"
          ></app-button-atom>
        }
      </app-pat-base-modal>
    }
  </div>
}

@if (errorMessage) {
  <div class="flex min-h-screen w-full items-center justify-center px-5 pb-64 pt-6">
    <app-pat-checks-error
      [error]="errorMessage"
      [displayRetryButton]="true"
    ></app-pat-checks-error>
  </div>
}
